import React, { FC } from 'react';

import './ChallengeDetail.css';

interface ChallengeDetailProps { }

const ChallengeDetail: FC<ChallengeDetailProps> = () => (
  <div className="ChallengeDetail" data-testid="ChallengeDetail">


  </div>
);

export default ChallengeDetail;
